import { Link, useLocation } from 'react-router';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { useAppSelector, selectIncident } from 'slices/commonSelectors';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useCurrentPeriod } from 'components/IAP/hooks/incidentHooks';

export const PratusHeaderNavTabs: React.FC = () => {
  const currentIncident = useAppSelector(selectIncident);
  const incidentId = currentIncident?.id;
  const location = useLocation();

  const { periodNumber } = useCurrentPeriod();

  return (
    <div className="d-flex align-items-center flex-nowrap flex-shrink-0">
      <Link to={`/iap/${incidentId}/notifications`}>
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => <Tooltip {...props}>Notifications</Tooltip>}
        >
          <StylishNewButton
            className={
              location.pathname === `/iap/${incidentId}/notifications`
                ? 'button--primary me-1'
                : 'button--secondary me-1'
            }
          >
            <SharedIcon iconName="notifications" />
          </StylishNewButton>
        </OverlayTrigger>
      </Link>
      {periodNumber !== 0 && (
        <>
          <Link to={`/iap/${incidentId}/resources`}>
            <OverlayTrigger
              placement="bottom"
              overlay={(props) => <Tooltip {...props}>Resources</Tooltip>}
            >
              <StylishNewButton
                className={
                  location.pathname === `/iap/${incidentId}/resources`
                    ? 'button--primary me-1'
                    : 'button--secondary me-1'
                }
              >
                <SharedIcon iconName="box" />
              </StylishNewButton>
            </OverlayTrigger>
          </Link>
          <Link to={`/iap/${incidentId}/roster`}>
            <OverlayTrigger
              placement="bottom"
              overlay={(props) => <Tooltip {...props}>Incident Roster</Tooltip>}
            >
              <StylishNewButton
                className={
                  location.pathname === `/iap/${incidentId}/roster`
                    ? 'button--primary me-1'
                    : 'button--secondary me-1'
                }
              >
                <SharedIcon iconName="people" />
              </StylishNewButton>
            </OverlayTrigger>
          </Link>
        </>
      )}
      <Link to={`/iap/${incidentId}/dashboard`}>
        <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip {...props}>
              {periodNumber === 0 ? 'ICS-201 Workspace' : 'Planning P'}
            </Tooltip>
          )}
        >
          <StylishNewButton
            className={
              location.pathname === `/iap/${incidentId}/dashboard`
                ? 'button--primary me-1'
                : 'button--secondary me-1'
            }
          >
            {periodNumber === 0 ? (
              <SharedIcon iconName="description" />
            ) : (
              <SharedIcon iconName="local_parking" />
            )}
          </StylishNewButton>
        </OverlayTrigger>
      </Link>
    </div>
  );
};
